var _defs, _g, _text, _text2, _text3, _text4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMedalGuia(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Medalla_Gu\\xEDa",
    "data-name": "Medalla Gu\\xEDa",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 197,
    height: 146,
    viewBox: "0 0 197 146",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_86266",
    "data-name": "Rect\\xE1ngulo 86266",
    width: 197,
    height: 146,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_19209",
    "data-name": "Grupo 19209"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_19208",
    "data-name": "Grupo 19208",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107565",
    "data-name": "Trazado 107565",
    d: "M50.636,120.825c-5.965-1.356-10.987-2.845-15.356-4.246l-.009.044c-.831,3.912-1.463,6.841-1.463,6.841-18.6-2.138-28.19-12.3-28.19-12.3l11.776-3.181L14.537,91.03c6,2.938,10.424,4.92,15,5.754l3.223-14.549c.375.537,2.859,1.822,7.439,3.323V24.584A9.812,9.812,0,0,1,46,15.737l4.575-2.123A115.312,115.312,0,0,1,151.4,15.645a9.778,9.778,0,0,1,5.419,8.654V85.562c4.593-1.5,7.081-2.79,7.461-3.329l3.223,14.546c4.568-.839,8.991-2.81,14.978-5.749l-2.857,16.95,11.777,3.181s-9.59,10.164-28.191,12.3v-.007c-.034-.163-.671-3.113-1.492-7-3.927,1.116-8.944,2.42-14.815,3.688-10.474,13.8-28.241,22.871-48.4,22.871-19.826,0-37.34-8.778-47.875-22.2",
    transform: "translate(-0.012 -0.01)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107566",
    "data-name": "Trazado 107566",
    d: "M50.636,120.825c-5.965-1.356-10.987-2.845-15.356-4.246l-.009.044c-.831,3.912-1.463,6.841-1.463,6.841-18.6-2.138-28.19-12.3-28.19-12.3l11.776-3.181L14.537,91.03c6,2.938,10.424,4.92,15,5.754l3.223-14.549c.375.537,2.859,1.822,7.439,3.323V24.584A9.812,9.812,0,0,1,46,15.737l4.575-2.123A115.312,115.312,0,0,1,151.4,15.645a9.778,9.778,0,0,1,5.419,8.654V85.562c4.593-1.5,7.081-2.79,7.461-3.329l3.223,14.546c4.568-.839,8.991-2.81,14.978-5.749l-2.857,16.95,11.777,3.181s-9.59,10.164-28.191,12.3v-.007c-.034-.163-.671-3.113-1.492-7-3.927,1.116-8.944,2.42-14.815,3.688-10.474,13.8-28.241,22.871-48.4,22.871C78.684,143.021,61.171,134.242,50.636,120.825Z",
    transform: "translate(-0.012 -0.01)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107567",
    "data-name": "Trazado 107567",
    d: "M43.952,91.13c0,26.762,24.444,48.452,54.6,48.452s54.6-21.692,54.6-48.452V28.419a9.158,9.158,0,0,0-5.075-8.1,107.962,107.962,0,0,0-94.4-1.9L49.39,20.4a9.186,9.186,0,0,0-5.438,8.285Z",
    transform: "translate(-0.096 -0.029)",
    fill: "#fce3ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107568",
    "data-name": "Trazado 107568",
    d: "M153.069,26.148a8.838,8.838,0,0,1,.234,1.09,8.838,8.838,0,0,0-.234-1.09",
    transform: "translate(-0.336 -0.089)",
    fill: "#e23030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107569",
    "data-name": "Trazado 107569",
    d: "M152.049,23.8a9.04,9.04,0,0,1,.993,2.229,8.951,8.951,0,0,0-.993-2.229",
    transform: "translate(-0.333 -0.081)",
    fill: "#e23030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107570",
    "data-name": "Trazado 107570",
    d: "M135.524,118.325a41.346,41.346,0,0,0,11.915-28.774v-57a8.2,8.2,0,0,0-4.5-7.23,95.73,95.73,0,0,0-84.612-1.715L54.516,25.4a8.223,8.223,0,0,0-4.827,7.4V89.552a41.429,41.429,0,0,0,12.427,29.294",
    transform: "translate(-0.109 -0.05)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107571",
    "data-name": "Trazado 107571",
    d: "M66.089,57.4h23.83V47.859H66.847l-4.034,5.175Z",
    transform: "translate(-0.138 -0.163)",
    fill: "#cad79f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107572",
    "data-name": "Trazado 107572",
    d: "M96.452,57.959h9.829V48.422H96.765",
    transform: "translate(-0.212 -0.165)",
    fill: "#cad79f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107573",
    "data-name": "Trazado 107573",
    d: "M120.428,44.59H80.55V35.054h38.608l6.752,5.175Z",
    transform: "translate(-0.177 -0.119)",
    fill: "#f7e99c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107574",
    "data-name": "Trazado 107574",
    d: "M89.134,45.614V94.688h7.3V44h-7.3Z",
    transform: "translate(-0.195 -0.15)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107575",
    "data-name": "Trazado 107575",
    d: "M137.041,60.06a11.066,11.066,0,1,1-11.066-11.052A11.059,11.059,0,0,1,137.041,60.06",
    transform: "translate(-0.252 -0.167)",
    fill: "#fdab68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107576",
    "data-name": "Trazado 107576",
    d: "M134.07,60.113a8.044,8.044,0,1,1-8.044-8.035,8.039,8.039,0,0,1,8.044,8.035",
    transform: "translate(-0.259 -0.177)",
    fill: "#fed5b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107577",
    "data-name": "Trazado 107577",
    d: "M113.2,58.928c.01.1.019.2.029.3,0,.039.011.077.013.094A12.738,12.738,0,0,1,134.8,50.878a12.483,12.483,0,0,1,3.906,8.479c.01-.058.02-.127.031-.2V60.9c-.01-.043-.02-.085-.029-.128a12.773,12.773,0,0,1-11.969,12l.251.032h-2.256l.46-.033a12.5,12.5,0,0,1-8.247-3.723,12.282,12.282,0,0,1-3.7-8.269c0,.04-.009.068-.011.1l-.039.431Zm1.71,1.106a11.057,11.057,0,1,0,11.06-11.018,11.026,11.026,0,0,0-11.06,11.018",
    transform: "translate(-0.248 -0.161)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107578",
    "data-name": "Trazado 107578",
    d: "M125.993,69a8.943,8.943,0,0,1-6.829-3.151,8.685,8.685,0,0,1-1.721-3.119,8.224,8.224,0,0,1-.366-1.89c-.019-.3-.042-.593-.04-.889a8.765,8.765,0,0,1,.308-2.21c.035-.13.07-.259.114-.386a.851.851,0,0,1,1.639.447c-.08.348-.178.693-.241,1.042a6.821,6.821,0,0,0-.084,1.831,7.094,7.094,0,0,0,.485,2.057,7.211,7.211,0,0,0,2.536,3.217,6.672,6.672,0,0,0,2.767,1.192,7.106,7.106,0,0,0,7.061-2.569,6.629,6.629,0,0,0,1.431-3.01,7.231,7.231,0,0,0-5.71-8.589,7.155,7.155,0,0,0-3.519.193.834.834,0,0,1-.951-.284.847.847,0,0,1,.426-1.346,7.549,7.549,0,0,1,1.383-.321,9.114,9.114,0,0,1,1.631-.084,8.73,8.73,0,0,1,2.447.434,8.838,8.838,0,0,1,2.457,1.261,8.986,8.986,0,0,1,2.007,2.005,8.871,8.871,0,0,1,1.523,3.458,8.449,8.449,0,0,1,.175,2.194,8.96,8.96,0,0,1-6.98,8.3,8.652,8.652,0,0,1-1.948.217",
    transform: "translate(-0.257 -0.174)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107579",
    "data-name": "Trazado 107579",
    d: "M125.133,64.552c.008-.264.006-.257-.236-.349a5.123,5.123,0,0,1-.594-.256.84.84,0,0,1,.348-1.585,1.35,1.35,0,0,1,.433.087c.142.043.274.114.414.163a.842.842,0,0,0,1.073-.432.832.832,0,0,0-.4-1.1c-.283-.143-.584-.252-.877-.376a2.538,2.538,0,0,1-.244-4.648.142.142,0,0,0,.1-.151,4.487,4.487,0,0,1,.02-.635.829.829,0,0,1,.829-.722.839.839,0,0,1,.837.738,2.887,2.887,0,0,1,.017.455c0,.107.04.142.135.175a6.694,6.694,0,0,1,.708.285.83.83,0,0,1,.427.949.842.842,0,0,1-.812.644,1.724,1.724,0,0,1-.45-.109c-.186-.058-.362-.147-.551-.186a.809.809,0,0,0-.9.526.82.82,0,0,0,.382,1.028c.3.144.6.261.908.385a2.588,2.588,0,0,1,1.448,1.376,2.529,2.529,0,0,1-1.117,3.24.272.272,0,0,0-.176.3,2.793,2.793,0,0,1-.019.54.845.845,0,0,1-.842.711.835.835,0,0,1-.821-.718c-.017-.112-.021-.225-.031-.338",
    transform: "translate(-0.271 -0.186)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107580",
    "data-name": "Trazado 107580",
    d: "M119.423,54.36a.849.849,0,0,1,.835-.852.853.853,0,1,1-.835.852",
    transform: "translate(-0.262 -0.182)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107581",
    "data-name": "Trazado 107581",
    d: "M89.491,94.631a1.758,1.758,0,0,1-.715-1.625c.026-4.418.013-8.836.013-13.253v-.744c-2.735-.443-4.479,1.03-4.5,3.71a27.713,27.713,0,0,1-.138,3.983,5.444,5.444,0,0,1-5.3,4.55c-1.872.041-3.745.017-5.617.009-.808,0-1.316-.473-1.294-1.154.021-.656.509-1.078,1.293-1.082,1.755-.01,3.51,0,5.265,0a3.365,3.365,0,0,0,3.544-3.513c.009-1.145-.022-2.291.013-3.435a5.611,5.611,0,0,1,5.355-5.383c.42-.017.841,0,1.317,0V49.752h-.726c-6.53,0-13.059-.006-19.588.015a2.279,2.279,0,0,0-1.156.352c-1.495.951-2.957,1.95-4.53,3,1.139.757,2.251,1.4,3.248,2.186a5.794,5.794,0,0,0,3.939,1.215c4.984-.084,9.969-.032,14.954-.031a3.725,3.725,0,0,1,.7.02,1.112,1.112,0,0,1,.033,2.2,2.938,2.938,0,0,1-.63.025c-5.686,0-11.374.013-17.061-.019a2.946,2.946,0,0,1-1.488-.452c-1.951-1.245-3.866-2.544-5.784-3.841-.378-.255-.709-.582-1.063-.875V52.7c.353-.293.683-.619,1.062-.875,1.858-1.256,3.74-2.477,5.589-3.745a3.142,3.142,0,0,1,1.887-.581c6.595.022,13.189.013,19.784.013h.843V45.265c-2.541,0-5.04,0-7.537,0-1.008,0-1.4-.395-1.4-1.4q-.007-4.2,0-8.408c0-1.014.39-1.406,1.392-1.409,2.269-.006,4.537,0,6.805,0h.788c0-1,.049-1.907-.014-2.81a1.788,1.788,0,0,1,1.006-1.823c1.1-.656,2.149-1.4,3.221-2.1h.7c1.082.736,2.15,1.492,3.249,2.2a1.623,1.623,0,0,1,.833,1.568c-.04.972-.01,1.945-.01,2.965h2.462c1.4,0,2.807-.012,4.211.007a1.108,1.108,0,0,1,1.184,1.118,1.131,1.131,0,0,1-1.192,1.115c-.187.01-.374,0-.562,0h-21.8v6.705c.143.011.253.026.365.026q17.968,0,35.936,0a1.035,1.035,0,0,0,.535-.1c1.616-1.057,3.222-2.132,4.915-3.258-1.3-.871-2.554-1.638-3.725-2.514a4.393,4.393,0,0,0-2.916-.874c-2.689.065-5.38.028-8.071.016a1.12,1.12,0,0,1-1.23-1.144,1.135,1.135,0,0,1,1.214-1.092c.094,0,.188,0,.281,0,3.111,0,6.223-.017,9.334.019a2.717,2.717,0,0,1,1.358.418c1.948,1.248,3.868,2.539,5.785,3.833a14.382,14.382,0,0,1,1.117.92v.841c-.371.308-.718.651-1.117.919-1.879,1.269-3.781,2.5-5.653,3.78a2.837,2.837,0,0,1-1.7.5q-13.265-.021-26.532-.009h-.891V92.338h4.44V75.043c0-.187-.007-.375,0-.561a1.124,1.124,0,0,1,1.142-1.162,1.109,1.109,0,0,1,1.092,1.141c.025.717.006,1.436.006,2.219h.753q7.3,0,14.6,0a3.382,3.382,0,0,0,3.749-3.381,1.121,1.121,0,1,1,2.239.1,5.607,5.607,0,0,1-5.653,5.516c-4.913.021-9.826.006-14.74.007h-.947v.761c0,4.44-.012,8.881.013,13.319a1.765,1.765,0,0,1-.714,1.626Zm6.038-60.618a4.512,4.512,0,0,1,.007-.81,2.475,2.475,0,0,0-1.611-3.04c-.21-.09-.49-.359-.592-.3-.779.458-1.523.977-2.271,1.485-.038.025-.025.134-.025.2,0,.81,0,1.621,0,2.462Z",
    transform: "translate(-0.131 -0.093)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107582",
    "data-name": "Trazado 107582",
    d: "M104.559,56.554v-6.7H97.854v.811q0,9.4,0,18.79a3.89,3.89,0,0,1-.019.7,1.114,1.114,0,0,1-2.209,0,3.483,3.483,0,0,1-.017-.63q0-10.165,0-20.332c0-1.29.323-1.612,1.613-1.612q4.071,0,8.143,0c1.1,0,1.474.373,1.475,1.471q0,4.136,0,8.273c0,1.1-.374,1.471-1.474,1.474-1.31,0-2.62.007-3.93,0-.827,0-1.329-.44-1.329-1.12s.5-1.111,1.329-1.118c1.025-.009,2.05,0,3.124,0",
    transform: "translate(-0.21 -0.162)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107583",
    "data-name": "Trazado 107583",
    d: "M101.288,52.087a1.118,1.118,0,1,1-1.171,1.06,1.131,1.131,0,0,1,1.171-1.06",
    transform: "translate(-0.22 -0.177)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107584",
    "data-name": "Trazado 107584",
    d: "M68.925,52.627c.556,0,1.113-.012,1.668,0a.848.848,0,1,1-.006,1.692q-1.667.021-3.337,0a.848.848,0,1,1,.006-1.692c.556-.015,1.113,0,1.668,0",
    transform: "translate(-0.145 -0.179)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107585",
    "data-name": "Trazado 107585",
    d: "M83.195,54.324c-.7,0-1.4.012-2.105,0a1.129,1.129,0,0,1-1.236-1.14,1.116,1.116,0,0,1,1.208-1.094q2.14-.024,4.281,0a1.122,1.122,0,1,1,.028,2.234c-.724.017-1.45,0-2.175,0",
    transform: "translate(-0.175 -0.177)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107586",
    "data-name": "Trazado 107586",
    d: "M76.437,52.087a1.117,1.117,0,1,1-1.088,1.144,1.129,1.129,0,0,1,1.088-1.144",
    transform: "translate(-0.165 -0.177)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107587",
    "data-name": "Trazado 107587",
    d: "M95.6,34.022H91.105c0-.84,0-1.651,0-2.462,0-.069-.013-.177.025-.2.748-.508,1.492-1.026,2.271-1.485.1-.06.382.209.592.3a2.475,2.475,0,0,1,1.611,3.04,4.512,4.512,0,0,0-.007.81",
    transform: "translate(-0.2 -0.102)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107588",
    "data-name": "Trazado 107588",
    d: "M95.585,40.815c-2.878,0-5.756.007-8.634-.01a1.17,1.17,0,0,1-1.388-1.372,1.489,1.489,0,0,1,.973-.818,10.172,10.172,0,0,1,2.028-.043h15.373c.188,0,.375-.007.562,0a1.129,1.129,0,0,1,1.19,1.117,1.112,1.112,0,0,1-1.188,1.116c-1.451.019-2.9.007-4.352.007H95.585",
    transform: "translate(-0.188 -0.131)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107589",
    "data-name": "Trazado 107589",
    d: "M115.817,40.814c-.7,0-1.4.014-2.105,0a1.121,1.121,0,1,1,.023-2.233q2.14-.021,4.282,0a1.119,1.119,0,0,1,1.212,1.091,1.133,1.133,0,0,1-1.236,1.142c-.724.016-1.45,0-2.175,0",
    transform: "translate(-0.247 -0.131)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107590",
    "data-name": "Trazado 107590",
    d: "M109.141,38.577A1.117,1.117,0,1,1,108,39.665a1.127,1.127,0,0,1,1.144-1.088",
    transform: "translate(-0.237 -0.131)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107591",
    "data-name": "Trazado 107591",
    d: "M74.766,77.076A9.107,9.107,0,0,1,73.5,81.284l-5.6,6.569-5.182-8.117a6.225,6.225,0,0,1,10.362-6.9c.683,1.021,1.688,2.454,1.688,3.681Zm-4.378-.79A2.491,2.491,0,1,0,67.9,78.773a2.489,2.489,0,0,0,2.491-2.488",
    transform: "translate(-0.135 -0.239)",
    fill: "#7eccc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107592",
    "data-name": "Trazado 107592",
    d: "M60.613,78.191a14.49,14.49,0,0,0,2.424,5.731,26.129,26.129,0,0,0,4.57,5.119,1.083,1.083,0,0,0,1.733-.061c1.455-1.544,2.942-3.072,4.245-4.739a12.366,12.366,0,0,0,2.656-6.166,7.689,7.689,0,0,0-1.757-6.006,1.1,1.1,0,0,0-1.607-.236,1.124,1.124,0,0,0-.141,1.622c.094.135.2.257.3.392a5.357,5.357,0,0,1,.977,3.983C73.4,81.566,71,84.195,68.49,86.757c-.563-.552-1.091-1.016-1.556-1.535a15.7,15.7,0,0,1-3.881-6.484,5.614,5.614,0,0,1,6.3-7.187,1.175,1.175,0,0,0,1.427-.912,1.141,1.141,0,0,0-1.064-1.3,7.832,7.832,0,0,0-8.849,5.621,8.906,8.906,0,0,0-.312,2.261,6.911,6.911,0,0,0,.059.97",
    transform: "translate(-0.133 -0.236)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107593",
    "data-name": "Trazado 107593",
    d: "M65.088,77.1a3.366,3.366,0,1,1,3.414,3.35,3.375,3.375,0,0,1-3.414-3.35m4.485.014a1.119,1.119,0,1,0-1.126,1.093,1.13,1.13,0,0,0,1.126-1.093",
    transform: "translate(-0.143 -0.251)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107594",
    "data-name": "Trazado 107594",
    d: "M69.578,77.121A1.119,1.119,0,1,1,68.5,75.98a1.129,1.129,0,0,1,1.078,1.141",
    transform: "translate(-0.148 -0.259)",
    fill: "#18a8a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107595",
    "data-name": "Trazado 107595",
    d: "M154.363,96.69c8.511,1.131,13.777-.951,23.055-5.506l-2.676,15.873,11.028,2.98s-8.98,9.515-26.4,11.518c0,0-5.341-24.781-5.012-24.863",
    transform: "translate(-0.339 -0.311)",
    fill: "#f48eb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107596",
    "data-name": "Trazado 107596",
    d: "M159.384,121.625l-1.4-6.555,8.883-2.79Z",
    transform: "translate(-0.346 -0.382)",
    fill: "#d37aa3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107597",
    "data-name": "Trazado 107597",
    d: "M42.91,96.69c-8.511,1.131-13.778-.951-23.055-5.506l2.673,15.873L11.5,110.036s8.98,9.515,26.4,11.518c0,0,5.34-24.781,5.011-24.863",
    transform: "translate(-0.025 -0.311)",
    fill: "#f48eb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107598",
    "data-name": "Trazado 107598",
    d: "M37.941,121.625l1.375-6.445-8.859-2.9Z",
    transform: "translate(-0.067 -0.382)",
    fill: "#d37aa3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107599",
    "data-name": "Trazado 107599",
    d: "M166.589,112.179,160.1,82.921C159,84.5,138.394,93,98.53,93S38.061,84.507,36.957,82.921l-6.482,29.258c12.293,3.9,30.129,11.334,67.65,11.334a221.584,221.584,0,0,0,68.462-11.334",
    transform: "translate(-0.067 -0.282)",
    fill: "#f8b8d1"
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "G",
    transform: "translate(82.576 109.115) rotate(3.584)",
    fontSize: 12,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "G"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    id: "U",
    transform: "translate(94.206 109.764) rotate(0.134)",
    fontSize: 12,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "U"))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    id: "\\xCD",
    transform: "translate(105.121 109.679) rotate(-2.471)",
    fontSize: 12,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\xCD"))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    id: "A",
    transform: "translate(110.71 109.449) rotate(-5.16)",
    fontSize: 12,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "A"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedalGuia);
export default __webpack_public_path__ + "static/media/medal-guia.b32d57e5248d398260c2cd090fa06c88.svg";
export { ForwardRef as ReactComponent };